<template>
  <div class="grade-slider-container">
    <div class="slider-markers">
      <div class="marker"></div>
      <div class="marker"></div>
      <div class="marker"></div>
    </div>
    <input
      v-model="localValue"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      :style="{ '--fill-percentage': fillPercentage + '%' }"
      class="grade-slider"
      @input="onInput"
    />
  </div>
</template>

<script>
export default {
  name: "GradeSlider",
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 0.1,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    fillPercentage() {
      return (this.localValue / this.max) * 100;
    },
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },
  methods: {
    onInput(event) {
      const value = Number(event.target.value);
      this.localValue = value;
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.grade-slider-container {
  position: relative;
  flex: 1;
  margin: 0 8px;
}

.slider-markers {
  display: flex;
  position: absolute;
  top: 10px;
  justify-content: space-evenly;
  left: 10px;
  right: 10px;
  height: 8px;
  pointer-events: none;
  z-index: 1;
}

.marker {
  width: 6px;
  height: 6px;
  background-color: white;
  border-radius: 50%;
  top: 0;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.grade-slider {
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;
  /* creating a custom design */
  width: 100%;
  cursor: pointer;
  outline: none;
  border-radius: 7px;
  height: 8px;
  background: linear-gradient(
    to right,
    var(--color-stroke-primary) 0%,
    var(--color-stroke-primary) var(--fill-percentage, 0%),
    #e5e7eb var(--fill-percentage, 0%),
    #e5e7eb 100%
  );
  margin: 0;
  position: relative;
  z-index: 0;
}

/* Track: webkit browsers */
.grade-slider::-webkit-slider-runnable-track {
  height: 8px;
  background: transparent;
  border-radius: 7px;
}

/* Track: Mozilla Firefox */
.grade-slider::-moz-range-track {
  height: 8px;
  background: transparent;
  border-radius: 7px;
}

/* Thumb: webkit */
.grade-slider::-webkit-slider-thumb {
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;
  /* creating a custom design */
  background-color: white;
  border-radius: 50%;
  border: 4px solid var(--color-stroke-primary);
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-top: -4px;
  position: relative;
  z-index: 3;
}

/* Thumb: Firefox */
.grade-slider::-moz-range-thumb {
  background-color: white;
  border-radius: 50%;
  border: 4px solid var(--color-stroke-primary);
  width: 16px;
  height: 16px;
  cursor: pointer;
  z-index: 3;
}
</style>
